<template>
  <v-container>
        <endpoint-details v-model="detailsDialog" :endpoint="selectedEndpoint" @reload="this.closeDialog"
                          @close="closeDialog" :key="this.selectedEndpoint ? this.selectedEndpoint.id : -1"/>
    <h4 class="align-left pa-2 section-title">{{ currentRouteName }}</h4>
    <v-card>
      <v-card-title>
        <v-select
                label="Produkt"
                :items="products"
                v-model="selectedProduct"
                item-text="name"
                item-value="identifier"
                v-on:change="productChanged"
                persistent-hint
                return-object
                outlined
        ></v-select>
      </v-card-title>
        <template>
            <v-data-table
                    :headers="headers"
                    :items="endpoints"
                    :loading="endpoints.length === 0"
                    :options="tableOptions"
                    loading-text="Daten werden geladen .. Bitte warten"
                    class="elevation-1"
                    mobile-breakpoint="0"
            >
                <template v-slot:item="row">
                    <endpoint-row :endpoint="row.item"
                                  @click="endpointClicked"/>
                </template>

            </v-data-table>
        </template>
    </v-card>
  </v-container>
</template>
<!-- TODO change lang to ts instead js to enable typescript-->
<script lang="js">
  import productsApi from '../api/products'
  import endpointsApi from '../api/endpoints'
  import EndpointRow from '../components/EndpointRow'
  import EndpointDetails from './EndpointDetails'
  import ProductStore from "@/stores/ProductStore";
  import RouteInfo from "@/utils/RouteInfo";
  import SortUtil from "@/utils/sortUitl";

  export default {
    extends: RouteInfo,
    name: 'State',
    components: { EndpointRow, EndpointDetails},
    data: () => {
      return {
        products: [],
        endpoints: [],
        detailsDialog: false,
        selectedEndpoint: null,
        selectedProduct: ProductStore.getProduct(),
        tableOptions: {
          itemsPerPage: 10
        },
          headers: [
              { text: 'Endpunktname', value: 'name', align: 'left' },
              { text: 'URL', value: 'url', align: 'left' },
              { text: 'Anfrage-Methode', value: 'method', align: 'left' },
              { text: 'Server', value: 'endpoint_flavor.name', align: 'right' }
          ]
      }
    },
    mounted() {
      this.fetchProducts()
    },
    methods: {
      fetchProducts () {
        productsApi.getProducts().then((r) => {
          this.products = SortUtil.sortedNames(r.data)
          this.selectedProduct = ProductStore.getProduct() ? ProductStore.getProduct() : this.products[0]
          if(!ProductStore.getProduct()) {
            ProductStore.setProduct(this.products[0])
          }
          this.fetchEndpoints()
        })
      },
     fetchEndpoints () {
       ProductStore.setProduct(this.selectedProduct)
        endpointsApi.getEndpoints(this.selectedProduct.identifier).then((r) => {
            this.endpoints = r.data
            this.endpoints.forEach(ep => {
               ep.endpoint_flavor.name = ep.endpoint_flavor.name === 'live'? 'Liveserver': 'Testserver'
            })
        })
     },
     productChanged () {
       this.endpoints = []
       this.fetchEndpoints()
     },
     endpointClicked (endpoint) {
        this.selectedEndpoint = endpoint
        this.detailsDialog = true
     },
      closeDialog () {
          this.detailsDialog = false
          this.selectedEndpoint = null
      }
    },
    watch: {
      /* Hide the scrollbars when the dialog opens */
      detailsDialog: function (val) {
        document.querySelector('html').style.overflow = val ? 'hidden' : null
      }
    }
  }
</script>
